import { render, staticRenderFns } from "./productContract.vue?vue&type=template&id=0136af04&scoped=true"
import script from "./productContract.vue?vue&type=script&lang=js"
export * from "./productContract.vue?vue&type=script&lang=js"
import style0 from "./productContract.vue?vue&type=style&index=0&id=0136af04&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0136af04",
  null
  
)

export default component.exports